import {
  LIBRARY_DISCOUNT_PAGE_REQUEST,
  LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS,
  LIBRARY_DISCOUNT_DISCOUNTS_REQUEST,
  LIBRARY_DISCOUNT_ON_CLICK_ROW,
  LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD,
  LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE,
  LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET,
  LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE,
  LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_ON_CLICK_CANCEL
} from 'actions/library/discount/constants'
import {takeLatest, put, call, takeEvery} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {initialize, change, reset} from 'redux-form'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as actDiscount from 'actions/library/discount'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiDiscount from 'api/libraries/discounts'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpLibraryDiscount from 'mixpanel/library/discount'

function * fillSearchFormProfile (profile) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

function * fillForm (discount) {
  let formName = 'discount'
  yield put(initialize(formName, {
    id: discount.id,
    name: discount.name,
    amount: discount.amount ? discount.amount.toString() : discount.amount,
    typeAmount: discount.type === 'percentage'
  }))
}

export function * pageRequest () {
  // reset...
  yield put(actDiscount.setDiscounts([]))
  yield put(showPageLoadingSpinner(true))
  yield put(actDiscount.unSetDiscountDetail(null))
  yield put(actDiscount.setOutlets([]))
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiOutlets.outlets)
    yield put(actDiscount.setOutlets(response.data))

    let resProfile = yield call(apiProfile.getProfile)
    mpLibraryDiscount.libraryDiscountStart({outletId: resProfile.data.outlet_id[0]})

    yield call(fillSearchFormProfile, resProfile.data)

    let resDiscounts = yield call(apiDiscount.getDiscounts, {page: 1})
    let discounts = resDiscounts.data.results
    yield put(actDiscount.setDiscounts(discounts))
    yield put(actDiscount.setTotalPage(resDiscounts.data.total_pages))
    yield put(actDiscount.setCurrentPage(1))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * discountsRequest (action) {
  const {payload: {params, previousDiscounts}} = action
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiDiscount.getDiscounts, params)
    let discounts = previousDiscounts.concat(response.data.results)
    yield put(actDiscount.setDiscounts(discounts))
    yield put(actDiscount.setTotalPage(response.data.total_pages))
    yield put(actDiscount.setCurrentPage(params.page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * onChangeOutletIds (action) {
  yield put(actDiscount.setDiscounts([]))
  yield put(showPageLoadingSpinner(true))

  const {payload: {outletIds}} = action
  try {
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    const res = yield call(apiDiscount.getDiscounts, {page: 1})
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    yield put(actDiscount.setDiscounts(res.data.results))
    yield put(actDiscount.setTotalPage(res.data.total_pages))
    yield put(actDiscount.setCurrentPage(1))
    yield call(fillForm, {id: null, amount: null, name: null, type: 'percentage'})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield call(unSetDetailsDiscount)
    yield put(act.hideProgressBar())
  }
  yield put(showPageLoadingSpinner(false))
}

export function * setDetailsDiscount (action) {
  const {payload: {discount}} = action
  yield put(act.showProgressBar())
  // tahan bbrp ms karena component harus dirender dlu supaya gak muncul setengah isi
  yield put(actDiscount.setDiscountDetail(discount))
  yield call(delay, 750)
  yield call(fillForm, discount)
  yield put(act.hideProgressBar())
}

export function * unSetDetailsDiscount () {
  try {
    yield put(act.showProgressBar())
    yield put(actDiscount.unSetDiscountDetail())
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onClickCreateDiscount (action) {
  try {
    yield put(reset('discount'))
    yield put(act.showProgressBar())
    yield put(actDiscount.setNewDiscount())
    // tahan bbrp ms karena component harus dirender dlu supaya gak muncul setengah isi
    yield call(delay, 750)
    yield call(fillForm, {id: null, amount: null, name: null, type: 'percentage'})
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onChangeSwitchField () {
  let formName = 'discount'
  yield put(change(formName, 'amount', ''))
}

export function * submitFormCreate (request) {
  let {payload: {data, previousDiscounts}} = request
  yield put(act.showProgressBar())
  yield put(actDiscount.isSubmittingForm(true))
  mpLibraryDiscount.libraryDiscountCreate({discount: data, allOutlet: false})
  try {
    let response = yield call(apiDiscount.postDiscount, data)
    // set to reducers
    let discount = response.data
    const discounts = [discount]
    previousDiscounts.forEach(g => discounts.push(g))

    yield put(actNotif.success('Discount successfully created.'))
    yield put(actDiscount.setDiscounts(discounts))
    yield put(actDiscount.setDiscountDetail(discount))
    yield call(fillForm, discount)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actDiscount.isSubmittingForm(false))
  }
}

export function * submitFormCreateAllOutlet (request) {
  let {payload: {data, previousDiscounts}} = request
  mpLibraryDiscount.libraryDiscountCreate({discount: data, allOutlet: true})
  yield put(act.showProgressBar())
  yield put(actDiscount.isSubmittingForm(true))
  try {
    let response = yield call(apiDiscount.postCreateAllOutlet, data)
    // set to reducers
    let discount = response.data
    const discounts = [discount]
    previousDiscounts.forEach(g => discounts.push(g))

    yield put(actNotif.success('Discount successfully created.'))
    yield put(actDiscount.setDiscounts(discounts))
    yield put(actDiscount.setDiscountDetail(discount))
    yield call(fillForm, discount)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actDiscount.isSubmittingForm(false))
  }
}

export function * submitFormUpdate (request) {
  let {payload: {data, discountId, previousDiscounts}} = request
  yield put(act.showProgressBar())
  yield put(actDiscount.isSubmittingForm(true))
  try {
    let response = yield call(apiDiscount.putDiscount, discountId, data)
    // set to reducers
    let discount = response.data
    const discounts = []
    previousDiscounts.forEach(g => {
      if (g.id === discountId) {
        discounts.push(discount)
      } else {
        discounts.push(g)
      }
    })

    yield put(actNotif.success('Discount successfully updated.'))
    yield put(actDiscount.setDiscounts(discounts))
    yield put(actDiscount.setDiscountDetail(discount))
    yield call(fillForm, discount)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actDiscount.isSubmittingForm(false))
  }
}

export function * deleteDiscount (request) {
  let {payload: {discountId, previousDiscounts}} = request
  yield put(act.showProgressBar())
  try {
    yield call(apiDiscount.deleteDiscount, discountId)
    // set to reducers
    const discounts = []
    previousDiscounts.forEach((discount) => {
      if (discount.id !== discountId) {
        discounts.push(discount)
      } else {
        // this is the deleted discount, track to mixpanel
        mpLibraryDiscount.libraryDiscountDelete({discount})
      }
    })
    yield put(actDiscount.setDiscounts(discounts))
    yield put(actDiscount.setDeletedDiscount(null))
    yield put(actDiscount.hideDeleteDiscountModal())
    yield call(unSetDetailsDiscount)
    yield call(fillForm, {id: null, name: '', amount: null, typeAmount: 'percentage'})
    yield put(actNotif.success('Discount successfully deleted.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * askDeleteDiscount (request) {
  const {payload: {deletedDiscount}} = request
  yield put(actDiscount.setDeletedDiscount(deletedDiscount))
  yield put(actDiscount.showDeleteDiscountModal())
}

export function * cancelDeleteDiscount () {
  yield put(actDiscount.setDeletedDiscount(null))
  yield put(actDiscount.hideDeleteDiscountModal())
}

export function * onClickCancel (action) {
  yield put(actDiscount.unSetDiscountDetail())
  yield call(fillForm, {id: null, name: '', amount: null, typeAmount: 'percentage'})
}

export default function * saga () {
  yield takeLatest(LIBRARY_DISCOUNT_PAGE_REQUEST, pageRequest)
  yield takeLatest(LIBRARY_DISCOUNT_ON_CLICK_ROW, setDetailsDiscount)
  yield takeLatest(LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT, onClickCreateDiscount)
  yield takeLatest(LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD, onChangeSwitchField)
  yield takeEvery(LIBRARY_DISCOUNT_DISCOUNTS_REQUEST, discountsRequest)
  yield takeLatest(LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE, submitFormCreate)
  yield takeLatest(LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE, submitFormUpdate)
  yield takeLatest(LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET, submitFormCreateAllOutlet)
  yield takeLatest(LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT, askDeleteDiscount)
  yield takeLatest(LIBRARY_DISCOUNT_DELETE_DISCOUNT, deleteDiscount)
  yield takeLatest(LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT, cancelDeleteDiscount)
  yield takeLatest(LIBRARY_DISCOUNT_ON_CLICK_CANCEL, onClickCancel)
}



// WEBPACK FOOTER //
// ./app/sagas/library/discount.js